import AnimationClip from '../AnimationClip';
import GameObject from 'GameObject/GameObject';
import { delay } from 'Utility/Task/TaskQueue';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import Scene from 'Scene/Scene';
import { PlaySound } from '../../Audio/AudioHelper';
import Container from 'Prototype/Container';
import {
    StartAnimation,
} from '../AnimationHelper';
import TransformComponent from 'Component/Transform';
import { defaultCanvasSize } from 'Constants/Canvas';
import Game from 'Game';
import RewardTextEffect from 'Prototype/Effect/RewardTextEffect';

interface IFarmRewardCoinsData {
    scene: Scene;
    value: number;
    target?: GameObject;
    [key: string]: any
}

export class FarmRewardCoins extends AnimationClip<IFarmRewardCoinsData> {
    public *execute(
        animator: GameObject,
        meta: IFarmRewardCoinsData
    ): IterableIterator<number> {
        try {
            animator.scene.emit(RenderSystemEvent.BRING_TO_FRONT, animator);

            const rewardEffectContainer = GameObject.Instantiate(Container);
            const rewardTransform: TransformComponent = rewardEffectContainer.getComponent(
                TransformComponent
            );

            meta.target.addChild(rewardEffectContainer);
            animator.addChild(rewardEffectContainer);
            rewardTransform.x = defaultCanvasSize.x / 2;
            rewardTransform.y = defaultCanvasSize.y / 2;

            StartAnimation(rewardEffectContainer, 'RewardCoinsEffect', {
                value: 3, // amount of coins
                texture: 'coin-reward',
                targetPosition: meta.target.container.position,
            });

            const localeText = `+${Game.locale.getText('RewardCoins')}`;
            rewardEffectContainer.addChild(
                GameObject.Instantiate(RewardTextEffect, {
                    text: localeText.replace('[x]', meta.value.toString()),
                })
            );

            yield* delay(2000);
            rewardEffectContainer.destroy();

            PlaySound('coins-add');
        } catch (e) {
            console.warn('RewardCoins failed:', e);
        }
    }
}
